import React, { useState } from 'react';
import axios from 'axios';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await axios.post('/api/cms/applications', formData);
      setSubmitted(true);
      setFormData({ name: '', phone: '', email: '', service: '', message: '' });
    } catch (err) {
      setError(err.response?.data?.message || 'Ошибка отправки заявки');
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <h1>Контакты</h1>
        <p>Свяжитесь с нами для бесплатной консультации</p>
      </div>

      <div className="contact-container">
        <div className="contact-info">
          <div className="contact-card">
            <div className="contact-icon">📞</div>
            <h3>Телефоны</h3>
            <p><a href="tel:88006006541">8-800-600-65-41</a> (многоканальный)</p>
            <p><a href="tel:88617654111">8 (8617) 654-111</a></p>
          </div>
          <div className="contact-card">
            <div className="contact-icon">✉️</div>
            <h3>Email</h3>
            <p><a href="mailto:info@inet-sm.ru">info@inet-sm.ru</a></p>
            <p><a href="mailto:support@inet-sm.ru">support@inet-sm.ru</a> (техподдержка)</p>
            <p><a href="mailto:sales@inet-sm.ru">sales@inet-sm.ru</a> (коммерческие)</p>
          </div>
          <div className="contact-card">
            <div className="contact-icon">🕐</div>
            <h3>Режим работы</h3>
            <p><strong>Пн–Пт:</strong> 10:00–17:00</p>
            <p><strong>Сб–Вс:</strong> выходной</p>
            <p><strong>Аварийная служба:</strong> 24/7</p>
          </div>
          <div className="contact-card">
            <div className="contact-icon">📍</div>
            <h3>География работ</h3>
            <p>Новороссийск, Черноморское побережье</p>
            <p>От Анапы до Сочи</p>
          </div>
        </div>

        <div className="contact-form-section">
          <div className="contact-form-card">
            {submitted ? (
              <div className="success-message">
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
                <h2>Заявка отправлена!</h2>
                <p>Мы свяжемся с вами в ближайшее время.</p>
                <button className="btn btn-primary" onClick={() => setSubmitted(false)}>Отправить ещё</button>
              </div>
            ) : (
              <>
                <h2>Оставить заявку</h2>
                {error && <div className="alert alert-danger">{error}</div>}
                <form onSubmit={onSubmit} className="contact-form">
                  <div className="form-group">
                    <label htmlFor="name">Ваше имя</label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={onChange} placeholder="Иван Иванов" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Телефон</label>
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={onChange} placeholder="+7 (___) ___-__-__" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={onChange} placeholder="your@email.com" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="service">Интересующая услуга</label>
                    <select id="service" name="service" value={formData.service} onChange={onChange}>
                      <option value="">Выберите услугу</option>
                      <option value="hotel">Гостиничные решения</option>
                      <option value="networks">Сети и коммуникации</option>
                      <option value="automation">Автоматизация</option>
                      <option value="video">Видеонаблюдение</option>
                      <option value="wifi">Wi-Fi и HotSpot</option>
                      <option value="telephony">Телефония</option>
                      <option value="tv">Телевидение</option>
                      <option value="servers">Серверные комнаты</option>
                      <option value="barrier">Умный шлагбаум</option>
                      <option value="access">Контроль доступа</option>
                      <option value="workplaces">Рабочие места</option>
                      <option value="equipment">Подбор оборудования</option>
                      <option value="other">Другое</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">Сообщение</label>
                    <textarea id="message" name="message" value={formData.message} onChange={onChange} rows="4" placeholder="Опишите ваш проект или задачу..."></textarea>
                  </div>
                  <button type="submit" className="btn btn-primary btn-full">Отправить заявку</button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="company-info">
        <div className="container">
          <h2>Реквизиты компании</h2>
          <div className="company-details">
            <div className="detail-item"><span className="detail-label">Название:</span><span className="detail-value">ООО «СЕТЬМОНТАЖ»</span></div>
            <div className="detail-item"><span className="detail-label">Директор:</span><span className="detail-value">Обухов Дмитрий Игоревич</span></div>
            <div className="detail-item"><span className="detail-label">ИНН:</span><span className="detail-value">2315988927</span></div>
            <div className="detail-item"><span className="detail-label">КПП:</span><span className="detail-value">231501001</span></div>
            <div className="detail-item"><span className="detail-label">ОГРН:</span><span className="detail-value">1162315051942</span></div>
            <div className="detail-item"><span className="detail-label">Адрес:</span><span className="detail-value">353900, г. Новороссийск, ул. Рубина 105, лит «У»</span></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
